import SpeedTester from 'browser-speed-test';
import { setMenu, updateNetworkSpeed } from './../effects/actions';
import { store } from './../effects/store';
const processes = require('./../assets/mock-data/processes.json')
const wiseInfos = require('./../assets/mock-data/wise-infos.json')
const wicandersInfos = require('./../assets/mock-data/wicanders-infos.json')

export const isMobile = () => {
  return window.innerWidth < 811;
}

export const mobileClass = (string = "") => {
  return `${string}${isMobile() ? " mobile" : ""}`.trim()
}

export const getNetworkDownloadSpeed = async () => {
  const tester = new SpeedTester({ url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Google_2015_logo.svg/502px-Google_2015_logo.svg.png' });
  const speed = await tester.start();
  store.dispatch(updateNetworkSpeed(speed))
}

export const findOn = (currentSite) => {
  switch (currentSite) {
    case 'wise':
      return wiseInfos
    case 'wicanders':
      return wicandersInfos
    default:
      return processes
  }
}


export const getPanoramaObject = (type, currentSite) => {
  const pano = findOn(currentSite).find(x => x.id === type)
  if(pano === undefined) return {}
  return {
    url: pano.redirect,
    label: pano.label
  }
}

export const Util = {
  setTitle(locale) {
    switch (locale) {
      case "en":
        return "Amorim"
      case "pt":
        return "Amorim"
      default:
        return "Amorim"

    }
  }
}

export const renderCompass = (width = 25, height = 25) => (
  <div id="compass" ref={r => window.compass = r}>
    <svg width={width} height={height} viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" version="1.1">
      <path id="Shape" d="M38 19.5 C38 9.283 29.717 1 19.5 1 9.283 1 1 9.283 1 19.5 1 29.717 9.283 38 19.5 38 29.717 38 38 29.717 38 19.5 Z" fill="#e3f3f2" fillOpacity="0.5" stroke="none" />
      <path id="Path_3905-copy" d="M21.353 13.718 L23.87 26.019 18.945 22.705 13.022 23.112 Z" fill="#ffffff" fillOpacity="1" stroke="none" />
    </svg>
  </div>
)

export const renderCompassWithoutWindow = (mini) => (
  <>
    <circle cx="4.186" cy="4.186" r="4.186" stroke="#aedbd9" className="animation-pulse" />
    <circle cx="4.186" cy="4.186" r="4.686" fill="#aedbd9" className="animation-pulse" />
  </>
)

export const onClickMap = (id, currentSite, history) => { 
    let obj = {}
    if(id === "showroom"){
        history.push('/splash-split'); store.dispatch(setMenu(false))
    }else if(id === "amorim-florestal"){
      history.push('/vr/showroom/13'); store.dispatch(setMenu(false))
    }else if(id === "amorim-cork-composites"){
      history.push('/vr/showroom/19'); store.dispatch(setMenu(false))
    }else{
        obj = getPanoramaObject(id, currentSite)
        if(!obj.url) return;
        history.push(obj.url); store.dispatch(setMenu(false))
    }
}